document.addEventListener('DOMContentLoaded', function() {
    const openButton = document.getElementById('open-popup-productsoort-advies-aanvragen');
    const popup = document.getElementById('popup-productsoort');

    if (!openButton || !popup) {
        // Elements not found on this page, silently return
        return;
    }

    const popupOverlay = popup.querySelector('.popup-overlay');
    const popupContent = popup.querySelector('.popup-content');

    function openPopup() {
        // Enable pointer events
        popup.classList.remove('pointer-events-none');
        popup.classList.add('pointer-events-auto');

        // Fade in overlay and content
        setTimeout(() => {
            if (popupOverlay) {
                popupOverlay.classList.remove('opacity-0');
                popupOverlay.classList.add('opacity-100');
            }
            if (popupContent) {
                popupContent.classList.remove('opacity-0', 'scale-95');
                popupContent.classList.add('opacity-100', 'scale-100');
            }
        }, 10);

        document.body.style.overflow = 'hidden';
        console.log('Popup opened');
    }

    function closePopup() {
        // Fade out overlay and content
        if (popupOverlay) {
            popupOverlay.classList.remove('opacity-100');
            popupOverlay.classList.add('opacity-0');
        }
        if (popupContent) {
            popupContent.classList.remove('opacity-100', 'scale-100');
            popupContent.classList.add('opacity-0', 'scale-95');
        }

        // Remove pointer events after animation completes
        setTimeout(() => {
            popup.classList.remove('pointer-events-auto');
            popup.classList.add('pointer-events-none');
        }, 300); // Match the transition duration

        document.body.style.overflow = '';
    }

    // Open popup
    openButton.addEventListener('click', function(e) {
        e.preventDefault();
        openPopup();
    });

    // Close popup when clicking overlay
    if (popupOverlay) {
        popupOverlay.addEventListener('click', function() {
            closePopup();
        });
    }

    // Close popup when clicking close button
    const closeButton = popup.querySelector('.popup-close');
    if (closeButton) {
        closeButton.addEventListener('click', function() {
            closePopup();
        });
    }

    // Close popup on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('pointer-events-auto')) {
            closePopup();
        }
    });
});